'use client';

import { Alert } from '@magicschool/spellbook';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuizzesInWorkflows } from '@/features/quizzes/QuizPlacementProvider';
import { storage } from '@/features/storage';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { useStudentRoomsCount } from '@/hooks/useStudentRoomsCount';

type Props = { onDismiss?: () => void };

export function MagicStudentDisabledBanner({ onDismiss }: Props) {
  const intl = useIntl();
  const studentRooms = useQuizzesInWorkflows();
  const { magicStudentEnabledForUser } = useFeatureFlags();
  const [alertRead, setAlertRead] = useState(storage.getItem('magicStudentDisabledAlertRead') === 'true');
  const studentRoomCount = useStudentRoomsCount();

  if (magicStudentEnabledForUser || alertRead || studentRoomCount === null || studentRoomCount === 0) return null;

  return (
    // Announced by the PageBannerRegion this banner renders in.
    <Alert
      role="presentation"
      status="info"
      variant="banner"
      onDismiss={() => {
        setAlertRead(true);
        storage.setItem('magicStudentDisabledAlertRead', 'true');
        onDismiss?.();
      }}
      text={{ dismissButtonLabel: intl.formatMessage({ id: 'close', defaultMessage: 'Close' }) }}
    >
      <Alert.Title>
        <FormattedMessage id={studentRooms ? 'toast.student-rooms-disabled-title' : 'toast.magic-student-disabled-title'} />
      </Alert.Title>
      <Alert.Content>
        <FormattedMessage id={studentRooms ? 'toast.student-rooms-disabled' : 'toast.magic-student-disabled'} />
      </Alert.Content>
    </Alert>
  );
}
